import { BaseEntity } from 'yt-ng-framework';

export class KomitentVoziloView extends BaseEntity {
    constructor(){
        super();
    }
    KomitentID: number = null;
    KomitentNaziv: string = null;
    Naziv: string = null;
    RgBr: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.KomitentID = input.KomitentID;
        this.Naziv = input.Naziv;
        this.RgBr=input.RgBr;
        
        return this;
    }

    Serialize(input: KomitentVoziloView){
        return input;
    }
}